import { createApi } from "@reduxjs/toolkit/query/react";

import { allPagesOf } from "../allPages";
import { baseQueryWithReauth } from "../authorization/authService";

export const templateFileApi = createApi({
  reducerPath: "templateFileApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["TemplateFile"],
  endpoints: (builder) => ({
    // Every page of the template files; the page shows them all, as it did with its one page
    // of 10 (#136). The argument is the page's own and no longer limits the list.
    getTemplateFiles: builder.query({
      queryFn: allPagesOf(() => ({ url: "/template_file/list" })),
      providesTags: (result) =>
        result
          ? [
              ...result.data.items.map(({ id }) => ({
                type: "TemplateFile",
                id,
              })),
              { type: "TemplateFile", id: "LIST" },
            ]
          : [{ type: "TemplateFile", id: "LIST" }],
    }),

    // Fetch a single template file by ID
    getTemplateFileById: builder.query({
      query: (id) => ({
        url: `/template_file/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "TemplateFile", id }],
    }),

    // Delete only the file (not the record)
    deleteTemplateFileOnly: builder.mutation({
      query: (id) => ({
        url: `/template_file/${id}/file-only`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "TemplateFile", id: "LIST" }],
    }),

    // Delete a template file by ID
    deleteTemplateFile: builder.mutation({
      query: (id) => ({
        url: `/template_file/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "TemplateFile", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTemplateFilesQuery,
  useGetTemplateFileByIdQuery,
  useDeleteTemplateFileMutation,
  useDeleteTemplateFileOnlyMutation,
} = templateFileApi;
